import React, { Suspense, useEffect } from 'react';
import { useContext } from "react";
import { Helmet } from 'react-helmet';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import swords from "./swords.png"
import styles from "./Navbar.module.css"
import { TinyColor } from '@ctrl/tinycolor';
import { Space, Button, ConfigProvider, Menu } from "antd"
import "./Navbar.css";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {LogoutOutlined, MailOutlined, SettingOutlined, SoundOutlined} from "@ant-design/icons"
import beta from "../../assets/beta.png"
import { useState } from "react";
import Spin from '../UI/Spin/Spin';
import { NAME_SERVER, MODE } from "../../Utils/NAME_HOST";
import Dropdown_languages from "../UI/Dropdown_languages";
import DropDownBalance from "../UI/DropDownBalance/DropDownBalance";
import Modal from "../Modals/Modal";
import RegForm from "../../Pages/RegForm/RegForm";
import LoginForm from "../../Pages/LoginForm/LoginForm";
import { fillTextPage } from "../../Utils/FillTextPage";
import FontFaceObserver from 'fontfaceobserver';
import { Tooltip } from "antd";
import Recovery from '../Modals/components/Recovery/Recovery';

const Navbar = () => {
    const { store } = useContext(Context);
    const [isAuthChecked, setAuthChecked] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(localStorage.getItem("typeBalance") === "true" ? true : false);
    const [stateNavOpen, setStateNavOpen] = useState(false);
    const [activeMenu,setActiveMenu] = useState(false);
    const location = useLocation();

    const [loadText, setLoadText] = useState(false)
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const [modelRegState, setModelRegState] = useState(false);
    const [modelEnterState, setModelEnterState] = useState(false);

    const room = queryParams.get('room');
    const promocode = queryParams.get("promocode")
    const freespins = queryParams.get("freespins")
    const bonus_dep = queryParams.get("bonus")
    const balance_bonus = queryParams.get("balance_bonus");

    const recovery_data = queryParams.get("recovery_data");
    const [modal_Recovery, setModalRecovery] = useState(recovery_data ? true : false)
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [statusContainerGamesFOOOTER, setStatusContainerGamesFOOTER] = useState(false);
    const colors1 = ['#6253E1', '#04BEFE'];
    const colors2 = ['#fc6076', '#ff9a44', '#ef9d43', '#e75516'];
    const colors3 = ['#40e495', '#30dd8a', '#2bb673'];
    const getHoverColors = (colors) =>
        colors.map((color) => new TinyColor(color).lighten(5).toString());
    const getActiveColors = (colors) =>
        colors.map((color) => new TinyColor(color).darken(5).toString());
    const [nubmer_activeFOOTER, setNumber_activeFOOTER] = useState(0);
    const itemsMenu = [
        {
          key: "1",
          icon: <SettingOutlined />,
          label: "Настройки",
        },
        {
            key: "2",
            icon: <SoundOutlined />,
            label: store.sound?"Выключить звук":"Включить звук",
            
          },
          {
            key: "3",
            icon: <LogoutOutlined />,
            label: "Выйти",
          },
      ];
    //change_navbar_links
    const links_data_phone = [

        { link: "/auction", img: "Auction-min.ico", name: "Аукцион", dis_button: true },
        { link: "/settings", img: "setting.png", name: "Настройки", dis_button: true },


    ]
    const links_data = [

        { link: "/slots", img: "slots.ico", name: store.dataLang["name_slot"] },
        { link: "/live_dealers", img: "liveDealers.ico", name: store.dataLang["liveDealers_name"] },
        { link: "/auction", img: "Auction-min.ico", name: "Аукцион", dis_button: true },

        {
            link: "/sapper",
            img: "sapper.ico",
            name: "Сапер"
        },
        {
            link: "/slot_game/9d9b5b34389337d4e43568b4ba2d56be97de447a_real",
            img: "aviator.ico",
            name: "Aviator"
        },

        {
            link: "/botsFight",
            img: "R_1.ico",
            name: store.dataLang["roulette_name"]
        }, { link: "/plinko", img: "P_1.ico", name: store.dataLang["plinko_name"] }, {
            img: "W_1.ico",
            link: "/simple_roulete",
            name: store.dataLang["wheel_name"]
        }, { link: "/list_room_cost", img: "S_1.ico", name: store.dataLang["money_rooms_name"] }
        , { link: "/enter_room_free", img: "F_1.ico", name: store.dataLang["free_rooms_name"] },
        // { link: "https://t.me/snake_money_news", img: "telegram_icon.png", name: "Telegram Channel", target: "_blank" },

    ]

    const link_params_login_redirect = room ? "?room=" + room : ""
    const acceptet_locathion_for_unauth = ["/login", "/", "/reg", "/slots", "/live_dealers", "/test", "/page", "/tournaments"]

    const toggleDropdown = () => {
        localStorage.setItem("typeBalance", !isDropdownOpen)
        setIsDropdownOpen(!isDropdownOpen);
    };
    useEffect(() => {

        const checkAuth = async () => {
            try {
                await fillTextPage("all", store)
                console.log("check")


                store.isLoading = true

                if (localStorage.getItem("token")) {
                    const response = await store.checkAuth();

                    if (!store.isAuth) {
                        if (!acceptet_locathion_for_unauth.includes("/" + location.pathname.split("/")[1]) && ((location.pathname.indexOf("slot_game") === -1 && location.pathname.indexOf("_demo") === -1))) {

                            navigate("")
                            setModelRegState(true)

                        }
                    }
                    setAuthChecked(true)
                } else {
                    if (!acceptet_locathion_for_unauth.includes("/" + location.pathname.split("/")[1]) && ((location.pathname.indexOf("slot_game") === -1 && location.pathname.indexOf("_demo") === -1))) {
                        navigate("")
                        setModelRegState(true)
                    }

                }
            } catch (e) {
                window.location.reload();


            } finally {
                store.isLoading = false


                setAuthChecked(true)

            }

        };
        if (queryParams.get("modal")) {
            setModelRegState(true)
        }


        checkAuth();
    }, []);
    const showNavAuto = () => {
        const nav = document.querySelector(".l-navbar"),
            bodypd = document.getElementById('body-pd'),
            headerpd = document.getElementById('header')
        if (!nav.classList.contains("show")) {
            setStateNavOpen(true)
            nav.classList.add('show')
            // change icon
            //             toggle.classList.toggle('bx-x')
            // add padding to body

            // add padding to header
            headerpd.classList.toggle('body-pd')
        } else {
            setStateNavOpen(false)
            nav.classList.remove("show")
            // toggle.classList.remove("bx-x")
            headerpd.classList.remove("body-pd")

        }
    }
    const showNavbar = (toggleId, navId, bodyId, headerId) => {
        setNumber_activeFOOTER(0);

        const toggle = document.getElementById('header-toggle'),
            nav = document.querySelector(".l-navbar"),
            bodypd = document.getElementById('body-pd'),
            headerpd = document.getElementById('header')

        // Validate that all variables exist
        if (!nav.classList.contains("show")) {
            setStateNavOpen(true)
            nav.classList.add('show')
            // change icon
            toggle.classList.toggle('bx-x')
            // add padding to body

            // add padding to header
            headerpd.classList.toggle('body-pd')
        } else {
            setStateNavOpen(false)
            nav.classList.remove("show")
            toggle.classList.remove("bx-x")
            headerpd.classList.remove("body-pd")

        }
        // show navbar


    }


    // Использование:


    useEffect(() => {
        if (!store.isLoading) {


            /*===== LINK ACTIVE =====*/
            const linkColor = document.querySelectorAll('.nav_link')


            function colorLink() {
                if (linkColor) {
                    linkColor.forEach(l => l.classList.remove('activeNav'))
                    this.classList.add('activeNav')
                }
            }

            linkColor.forEach(l => l.addEventListener('click', colorLink))

            var currentUrl = window.location.href.split("/");
            let cur = currentUrl[currentUrl.length - 1]
            const elem = document.querySelector(`a[href="/${cur}"]`)
            if (elem) {
                elem.classList.add("activeNav")
            }
        }
    }, [store.isLoading]);

    const [isNavOpen, setNavOpen] = useState(false);

    function formatCurrency(amount, type) {
        const currency = 'RUB';

        const formatter = new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: currency,
        });

        let formattedAmount = formatter.format(amount);
        if (type === "bonus") {
            formattedAmount = formattedAmount.replace("₽", "B")
        }
        return formattedAmount.replace(",00", '')
    }

    const toggleNav = () => {

        setNavOpen(!isNavOpen);
        if (!isNavOpen) {
            document.querySelector(".nav-item").classList.add("mt-2")
            if (document.querySelector(".information_user")) {

                document.querySelector(".information_user").classList.add("mt-2")

            }

        } else {
            document.querySelector(".nav-item").classList.remove("mt-2")
            if (document.querySelector(".information_user")) {

                document.querySelector(".information_user").classList.remove("mt-2")

            }
        }
    };
    async function onClickMenu(key){
        if (key === "1"){
            navigate("/settings")
            
        }
        if (key === "2"){
            store.set_sound_state(!store.sound)

        }
        if (key === "3"){
            await handleLogout();
        }
        setActiveMenu(false)
    }
    async function handleLogout() {
        await store.logout();
        window.location.reload();

    }

    if (isAuthChecked) {


        if (!store.isLoading && !store.user.login) {

            if (!store.isPhone) {
                return (
                    <div>

                        <header className="header" id="header">
                            <div className="header_toggle">

                                <a className="navbar-brand" style={{ marginLeft: "10px" }} href="/">

                                    <img src={NAME_SERVER + "/assets/" + "лого.png"} width={250} />


                                </a>

                            </div>
                            <div className="container_inf_user">
                                <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                    title="Турниры">
                                    <a style={{ marginRight: "10px" }} href='/tournaments'><img src={NAME_SERVER + "/assets/" + "tournaments_icon.png"} width={30} /></a>

                                </Tooltip>
                                <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                    title={store.dataLang["support_button"]}>
                                    <a className="wallet_nav_bar pink" target='blank'
                                        href="https://t.me/snake_money_w"><i
                                            className="fa-solid fa-envelope"></i></a>
                                </Tooltip>


                                <a className={"nav-logs  activeNav skeleton-button " + styles.buttonsHeader}
                                    style={{ color: "white", background: "linear-gradient(135deg, #6253E1, #04BEFE)" }}
                                    aria-current="page" onClick={() => setModelRegState(true)}>
                                    {store.dataLang["reg_name"]} <i className="fa-solid fa-user"></i>
                                </a>
                                <a style={{
                                    color: "white",
                                    background: "linear-gradient(116deg, #40e495, #30dd8a, #2bb673)"
                                }} className={"nav-logs center-element mx-2  skeleton-button " + styles.buttonsHeader}
                                    onClick={() => setModelEnterState(true)}>
                                    {store.dataLang["enter_name"]} <i className="fa-solid fa-right-to-bracket"></i>
                                </a>
                                <Dropdown_languages />
                            </div>
                        </header>

                        {/*<i className={"fa-solid "+(stateNavOpen?"fa-xmark":"fa-bars")+" toggler-icon"} id="header-toggle" onClick={showNavbar}></i>*/}

                        <div className="l-navbar" id="nav-bar">

                            <Modal type={"reg"} props={{ promocode, freespins, bonus_dep, balance_bonus }} Component={RegForm}
                                ModelState={modelRegState}
                                setModelState={setModelRegState} />


                            <Modal type={"reg"} Component={LoginForm} ModelState={modelEnterState}
                                setModelState={setModelEnterState} />

                            <Modal Component={Recovery} props={{ recovery_data, closeModal: () => setModalRecovery(false) }} ModelState={modal_Recovery} setModelState={() => setModalRecovery(false)} />
                            <nav className="nav">
                                <div>


                                    <div className="nav_list">


                                        {links_data.map(el =>

                                            <Tooltip zIndex={10003} color={"#4caf50"} align={{ offset: [-2, 10] }}
                                                placement="rightTop"
                                                title={el.name}>
                                                <a href={el.link} target={el.target} className="nav_link">
                                                    <img className={styles.imgNavigate}
                                                        src={NAME_SERVER + "/assets/" + el.img} />


                                                </a>
                                            </Tooltip>
                                        )}
                                        <i onClick={() => store.set_sound_state(!store.sound)} class={`fa-solid ${store.sound ? "fa-volume-high" : "fa-volume-xmark"} nav_icon`} style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}></i>


                                    </div>
                                </div>


                            </nav>

                        </div>
                    </div>
                )
            } else {
                return (
                    <div>

                        <header className="header" id="header">
                            <div className="header_toggle">

                                <a className="navbar-brand unreg" href="/">
                                    <img src={NAME_SERVER + "/assets/" + "лого.png"} width={120} />


                                </a>

                            </div>
                            <div className="container_inf_user">
                                <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                    title="Турниры">
                                    <a style={{ marginRight: "10px" }} href='/tournaments'><img src={NAME_SERVER + "/assets/" + "tournaments_icon.png"} width={35} /></a>

                                </Tooltip>

                                <a className={"nav-logs  activeNav skeleton-button " + styles.buttonsHeader}
                                    style={{ color: "white", background: "linear-gradient(135deg, #6253E1, #04BEFE)" }}
                                    aria-current="page" onClick={() => setModelRegState(true)}>
                                    {store.dataLang["reg_name"]} <i className="fa-solid fa-user"></i>
                                </a>
                                <a style={{
                                    color: "white",
                                    background: "linear-gradient(116deg, #40e495, #30dd8a, #2bb673)"
                                }} className={"nav-logs center-element skeleton-button " + styles.buttonsHeader}
                                    onClick={() => setModelEnterState(true)}>
                                    {store.dataLang["enter_name"]} <i className="fa-solid fa-right-to-bracket"></i>
                                </a>

                                <div className="header_lang_container">
                                    <Dropdown_languages />
                                </div>
                            </div>


                        </header>
                        <div className="l-navbar" id="nav-bar">


                            <nav className="nav">
                                <div>


                                    <div className="nav_list">


                                        {links_data.map(el =>
                                            <a href={el.link} target={el.target} className="nav_link">
                                                <img className={styles.imgNavigate}
                                                    src={NAME_SERVER + "/assets/" + el.img} />
                                                <span className="nav_name">{el.name}</span>
                                            </a>
                                        )}
                                        <i onClick={() => store.set_sound_state(!store.sound)} class={`fa-solid ${store.sound ? "fa-volume-high" : "fa-volume-xmark"} nav_icon`} style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}></i>



                                    </div>
                                </div>


                            </nav>
                        </div>
                        {stateNavOpen && <div className={styles.fadeOutFooter} onClick={showNavbar} />}

                        <div className="wrrapper-footer">

                            <Modal type={"reg"} props={{ promocode, freespins, bonus_dep, balance_bonus }} Component={RegForm}
                                ModelState={modelRegState}
                                setModelState={setModelRegState} />


                            <Modal type={"reg"} Component={LoginForm} ModelState={modelEnterState}
                                setModelState={setModelEnterState} />
                            <Modal Component={Recovery} props={{ recovery_data, closeModal: () => setModalRecovery(false) }} ModelState={modal_Recovery} setModelState={() => setModalRecovery(false)} />




                            {statusContainerGamesFOOOTER && <div className={styles.containerGamesF}>
                                {links_data.map(el =>
                                    <div onClick={() => { navigate(el.link); store.set_current_url(el.link); setStatusContainerGamesFOOTER(false) }} className={`${styles.blockGameF} ${store.current_url === el.link && styles.activeBlockGamef}`}>
                                        <img className={styles.imgNavigate}
                                            src={NAME_SERVER + "/assets/" + el.img} />
                                        {el.name}
                                    </div>
                                )}</div>}


                            <footer className="footer" id="footer">

                                <div className={`${styles.blockIcon}`} onClick={() => setModelRegState(true)}>

                                    <i class="fa-solid fa-gift"></i>
                                    <div>{store.dataLang["money_rooms_text2"]}</div>
                                </div>
                                <div className={`${styles.blockIcon}`} onClick={() => setModelRegState(true)}>

                                    <i class="fa-solid fa-coins"></i>
                                    <div>Аукцион</div>
                                </div>
                                <div className={`${styles.blockIcon}`} style={{ marginTop: "-25px", color: "white" }} onClick={() => setModelRegState(true)}>

                                    <div className={styles.blockIconSnake}><img width={40} height={40} src={NAME_SERVER + "/assets/" + "logo_s.png"} /></div>
                                    <div>Играть</div>
                                </div>

                                {/* <div className={styles.blockIcon} onClick={() => { store.set_state_chat(!store.state_chat) }}>

                                <i class="fa-solid fa-paper-plane"></i>
                                <div>Чат</div>
                            </div> */}
                                <a href="https://t.me/snake_money_w" target='blank'><div className={styles.blockIcon} onClick={showNavbar}>

                                    <i class="fa-regular fa-envelope"></i>
                                    <div>{store.dataLang["support_button"]}</div>
                                </div></a>
                                <div className={styles.blockIcon} onClick={showNavbar}>

                                    <i className={"fa-solid " + ("fa-bars") + " toggler-icon_phone"}
                                        id="header-toggle"></i>
                                    <div>Меню</div>
                                </div>









                            </footer>
                        </div>


                    </div>
                )
            }
        }
        if (!store.isLoading && store.user.login) {
            if (!store.isPhone) {


                return (
                    <Suspense fallback={<Spin />}>

                        <div>


                            <header className="header" id="header">
                                <div className="header_toggle">

                                    <a className="navbar-brand" href="/">
                                        <img src={NAME_SERVER + "/assets/" + "лого.png"} width={250} />


                                    </a>

                                </div>
                                <div className="container_inf_user">
                                    <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                        title="Турниры">
                                        <a style={{ marginRight: "10px" }} href='/tournaments'><img src={NAME_SERVER + "/assets/" + "tournaments_icon.png"} width={30} /></a>

                                    </Tooltip>



                                    <div className="balance_nav p-0 m-0  navbar-text ms-1">
                                        <DropDownBalance placement={"bottom"} balance={store.user.balance}
                                            balance_bonus_casino={store.user.balance_casino}
                                            balance_bonus_snake={store.user.bonus}
                                            freespins={store.user.freespins} />

                                    </div>
                                    <a className="wallet_nav_bar skeleton-button"
                                        href="/pay"><span>{store.dataLang["deposit_button"]}</span><i
                                            className="fa-solid fa-wallet"></i></a>
                                    <button className="wallet_nav_bar skeleton-button" style={{ backgroundColor: "purple", padding: "0.27rem 1rem" }}
                                        onClick={() => {
                                            store.set_bonus(true)
                                            navigate("/pay")
                                        }}><span>{store.dataLang["money_rooms_text2"]} <i class="fa-solid fa-gift"></i></span></button>

                                    <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                        title={store.dataLang["support_button"]}>
                                        <a className="wallet_nav_bar phone pink" target='blank'
                                            href="https://t.me/snake_money_w"><i
                                                className="fa-solid fa-envelope"></i></a>
                                    </Tooltip>


                                    <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                        title={store.dataLang["settings_name"]}>
                                        <a href="/settings" className="nav_icon"><i
                                            className='fa-solid fa-gear nav_icon'></i></a>
                                    </Tooltip>



                                    <Tooltip zIndex={10003} align={{ offset: [-8, 5] }} placement="bottom"
                                        title={store.dataLang["exit_name"]}>
                                        <i style={{ cursor: "pointer" }} onClick={handleLogout}
                                            className="fa-solid fa-right-from-bracket nav_icon logout"></i>
                                    </Tooltip>


                                </div>
                            </header>

                            {/*<i className={"fa-solid "+(stateNavOpen?"fa-xmark":"fa-bars")+" toggler-icon"} id="header-toggle" onClick={showNavbar}></i>*/}

                            <div className="l-navbar" id="nav-bar">
                                <Modal Component={Recovery} props={{ recovery_data, closeModal: () => setModalRecovery(false) }} ModelState={modal_Recovery} setModelState={() => setModalRecovery(false)} />

                                <nav className="nav">
                                    <div>


                                        <div className="nav_list">


                                            {links_data.map(el =>

                                                <Tooltip zIndex={100001} color={"#4caf50"} align={{ offset: [-2, 10] }}
                                                    placement="rightTop" title={el.name}>
                                                    <a href={el.link} target={el.target} className="nav_link">
                                                        <img className={styles.imgNavigate}
                                                            src={NAME_SERVER + "/assets/" + el.img} />


                                                    </a>
                                                </Tooltip>
                                            )}
                                            <i onClick={() => store.set_sound_state(!store.sound)} class={`fa-solid ${store.sound ? "fa-volume-high" : "fa-volume-xmark"} nav_icon`} style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}></i>


                                        </div>
                                    </div>


                                </nav>
                            </div>
                        </div>
                    </Suspense>


                );
            } else {
                return (


                    <div>
                        {activeMenu&&<div className='backgroundMenuClose' onClick={()=>setActiveMenu(false)}></div>}

                        <header className="header" id="header">
                            <div className="header_toggle">

                                <a className="navbar-brand" href="/">
                                    <img src={NAME_SERVER + "/assets/" + "лого.png"} width={150} />


                                </a>

                            </div>
                            <div className={styles.containerInfHeader}>
                                <Tooltip zIndex={10003} align={{ offset: [5, 10] }} placement="bottom"
                                    title="Турниры">
                                    <a style={{ marginRight: "10px" }} href='/tournaments'><img src={NAME_SERVER + "/assets/" + "tournaments_icon.png"} width={30} /></a>

                                </Tooltip>
                                <div className="balance_nav p-0 m-0  navbar-text ms-1">
                                    <DropDownBalance placement={"bottom"} balance={store.user.balance}
                                        balance_bonus_casino={store.user.balance_casino}
                                        balance_bonus_snake={store.user.bonus}
                                        freespins={store.user.freespins} />


                                </div>
                                <div className="wallet_nav_bar skeleton-button phone"
                                    onClick={() => { store.set_bonus(false); store.set_state_chat(false); navigate("/pay") }}><i
                                        className="fa-solid fa-wallet"></i></div>
                            </div>


                        </header>



                        <div className="l-navbar" id="nav-bar">

                            <nav className="nav">
                                <div>


                                    <div className="nav_list">


                                        {links_data_phone.map(el =>
                                            <a href={el.link} target={el.target} className="nav_link">
                                                <img className={styles.imgNavigate}
                                                    src={NAME_SERVER + "/assets/" + el.img} />
                                                <span className="nav_name">{el.name}</span>
                                            </a>
                                        )}
                                        <div className='nav_link' style={{}} onClick={handleLogout}><img className={styles.imgNavigate}
                                            src={NAME_SERVER + "/assets/" + "logout.png"} /><span className="nav_name">Выйти</span></div>
                                        <div className='nav_link' onClick={() => store.set_sound_state(!store.sound)}><i class={`fa-solid ${store.sound ? "fa-volume-high" : "fa-volume-xmark"} nav_icon`} style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}></i><span className="nav_name">{store.sound ? "Выключить звук" : "Включить звук"}</span></div>







                                    </div>
                                </div>


                            </nav>
                        </div>
                        {stateNavOpen && <div className={styles.fadeOutFooter} onClick={showNavbar}>

                        </div>}
                        {statusContainerGamesFOOOTER && <div className={styles.fadeOutGames} onClick={() => setStatusContainerGamesFOOTER(false)} />
                        }


                        <div className="wrrapper-footer">
                            <Modal Component={Recovery} props={{ recovery_data, closeModal: () => setModalRecovery(false) }} ModelState={modal_Recovery} setModelState={() => setModalRecovery(false)} />



                            {statusContainerGamesFOOOTER && <div className={styles.containerGamesF}>
                                {links_data.map(el =>
                                    !el.dis_button &&
                                    <div onClick={() => { navigate(el.link); store.set_current_url(el.link); setStatusContainerGamesFOOTER(false) }} className={`${styles.blockGameF} ${store.current_url === el.link && styles.activeBlockGamef}`}>
                                        <img className={styles.imgNavigate}
                                            src={NAME_SERVER + "/assets/" + el.img} />
                                        {el.name}
                                    </div>
                                )}</div>}


                            <footer className="footer" id="footer">
                                <div className={'containerMenu' + (activeMenu?" active":"")} style={{zIndex:activeMenu?10010:-1,pointerEvents:activeMenu?"auto":"none"}}><Menu
                                    style={{ width: 256 }}
                                    
                                    mode={"vertical"}
                                    onClick={async (e)=>await onClickMenu(e.key)}
                                    theme={"dark"}
                                    items={itemsMenu}
                                /></div>

                                <div className={`${styles.blockIcon} ${nubmer_activeFOOTER === 1 && styles.activeF}`} onClick={() => { setNumber_activeFOOTER(1); store.set_state_chat(false); store.set_bonus(true); navigate("/pay"); }}>

                                    <i class="fa-solid fa-gift"></i>
                                    <div>{store.dataLang["money_rooms_text2"]}</div>
                                </div>
                                <div className={`${styles.blockIcon} ${nubmer_activeFOOTER === 2 && styles.activeF}`} onClick={() => { setNumber_activeFOOTER(2); navigate("/auction"); store.set_state_chat(false) }}>

                                    <i class="fa-solid fa-coins"></i>
                                    <div>Аукцион</div>
                                </div>
                                <div className={`${styles.blockIcon}`} style={{ marginTop: "-25px", color: "white" }} onClick={() => { setStatusContainerGamesFOOTER(prev => !prev) }}>

                                    <div className={styles.blockIconSnake}><img width={40} height={40} src={NAME_SERVER + "/assets/" + "logo_s.png"} /></div>
                                    <div>Играть</div>
                                </div>

                                {/* <div className={styles.blockIcon} onClick={() => { store.set_state_chat(!store.state_chat) }}>

                                <i class="fa-solid fa-paper-plane"></i>
                                <div>Чат</div>
                            </div> */}
                                <a href="https://t.me/snake_money_w" target='blank'><div className={styles.blockIcon}>

                                    <i class="fa-regular fa-envelope"></i>
                                    <div>{store.dataLang["support_button"]}</div>
                                </div></a>

                                <div className={styles.blockIcon} onClick={()=>setActiveMenu(true)}>

                                    <i className={"fa-solid " + ("fa-bars") + " toggler-icon_phone"}
                                        id="header-toggle"></i>
                                    <div>Меню</div>
                                </div>









                            </footer>
                        </div>
                    </div>)

            }
        }
    }
};

export default observer(Navbar);